import React from 'react';
import { Plane, Zap } from 'lucide-react';
export function EliteUpsell() {
  return <section className="py-20 bg-[#FAF6EE]" data-id="element-72">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-73">
        <div className="text-center mb-16" data-id="element-74">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1F1A17] mb-4" data-id="element-75">
            ¿Qué agrega el Megapack Elite?
          </h2>
          <p className="text-xl text-gray-600" data-id="element-76">
            Por solo $9.000 más, llevás tu enseñanza al siguiente nivel.
          </p>
        </div>

        <div className="space-y-8" data-id="element-77">
          <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-gray-100" data-id="element-78">
            <div className="flex items-center mb-6" data-id="element-79">
              <div className="w-12 h-12 bg-brand-gold/10 text-brand-gold rounded-xl flex items-center justify-center mr-4" data-id="element-80">
                <Plane className="w-6 h-6" data-id="element-81" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-[#1F1A17]" data-id="element-82">
                Elite 1 — Método Viajero Express
              </h3>
            </div>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-83">
              <p data-id="element-84">
                El curso de 4 clases listo para vender a cualquier alumno que
                viaje a Italia. Incluye guion de venta word for word, materiales
                para el alumno, Cheat Sheet imprimible para llevar en el
                bolsillo y Certificado de finalización oficial.
              </p>
              <p className="font-bold text-[#1F1A17] bg-yellow-50 p-4 rounded-lg border border-yellow-100" data-id="element-85">
                Con el primer alumno viajero que cerrás con este método,
                recuperás el valor del Megapack completo.
              </p>
              <p data-id="element-86">
                No improvises más cuando alguien te diga "viajo a Italia el mes
                que viene." Ahora tenés exactamente qué decirle y qué cobrarle.
              </p>
            </div>
          </div>

          <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-gray-100" data-id="element-87">
            <div className="flex items-center mb-6" data-id="element-88">
              <div className="w-12 h-12 bg-brand-red/10 text-brand-red rounded-xl flex items-center justify-center mr-4" data-id="element-89">
                <Zap className="w-6 h-6" data-id="element-90" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-[#1F1A17]" data-id="element-91">
                Elite 2 — Corrección Automática Pro
              </h3>
            </div>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-92">
              <p data-id="element-93">
                Corregí a 20 alumnos en el tiempo que tardás en tomar un
                espresso.
              </p>
              <p data-id="element-94">
                Incluye Exámenes Espejo A1→C2 diseñados para corrección visual
                en 60 segundos, Rúbricas de tilde pre-hechas, Banco de feedback
                copy-paste y el Sistema de Autocorrección Guiada donde el alumno
                encuentra y corrige sus propios errores.
              </p>
              <p className="font-bold text-[#1F1A17] bg-green-50 p-4 rounded-lg border border-green-100" data-id="element-95">
                Las 2-3 horas que recuperás por semana son 10 horas por mes. Son
                120 horas por año de tu vida devuelta.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}